import { writable } from "svelte/store";
import { appManager } from "../../AppManager";
export class EditManager {
    constructor(parent, mapViewStore) {
        this.editApiUrlStore = writable(undefined);
        this.mapViewStore = mapViewStore;
        this.parent = parent;
        this.parent.getData().subscribe(scenario => {
            if (typeof scenario === "undefined") {
                this.editApiUrlStore.set(undefined);
                return;
            }
            this.editApiUrlStore.set(`${appManager.api.edit.url}${scenario.branchId}`);
        });
    }
    getEditApiUrlStore() {
        return this.editApiUrlStore;
    }
    getReadyStore() {
        return this.parent.getReadyStore();
    }
    getViewStore() {
        return this.parent.getViewStore();
    }
    getMapViewStore() {
        return this.mapViewStore;
    }
}
